import { render, staticRenderFns } from "./NoteAssessmentDetail.vue?vue&type=template&id=0131499c&"
import script from "./NoteAssessmentDetail.vue?vue&type=script&lang=js&"
export * from "./NoteAssessmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports